import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-business-executive',
  templateUrl: './business-executive.component.html',
  styleUrls: ['./business-executive.component.css']
})
export class BusinessExecutiveComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
